import { Collapse, Typography } from '@mui/material';
import { Query, Builder, Utils as QbUtils } from '@react-awesome-query-builder/mui';

import useSettings from '../hooks/useSettings';
import Form from '../Form';

interface QueryBuilderProps {
	/** The displayed query tree */
	currentTree: any;
	/** The QueryBuilder config */
	queryConfig: any;
	/** Function used to change the current query value */
	handleQueryChange: (newTree: any, conf: any) => void;
}

/** A dialog that show a query builder for a specified module */
export default function QueryBuilder({ currentTree, queryConfig, handleQueryChange }: QueryBuilderProps) {
	const { t } = useSettings();

	const renderBuilder = props => (
		<div className="query-builder qb-lite">
			<Builder {...props} />
		</div>
	);

	return (
		<Form id="queryBuilderForm">
			{/* QUERY BUILDER */}
			<Query {...queryConfig} value={currentTree} onChange={handleQueryChange} renderBuilder={renderBuilder} />
			{/* QUERY SQL PREVIEW */}
			{import.meta.env.DEV && (
				<Collapse in={currentTree.size > 2} className="mx-8">
					<Typography variant="subtitle2">{t('QUERY_BUILDER_PREVIEW')}</Typography>
					<div className="query-builder-result">
						<code>{JSON.stringify(QbUtils.sqlFormat(currentTree, queryConfig))}</code>
					</div>
				</Collapse>
			)}
		</Form>
	);
}
